import { postRequest, getRequest } from "./main";

export function createLobby() {
    return postRequest('/lobby/create/boat');
};

export function joinLobby(roomCode) {
    return getRequest('/lobby/join/boat/' + roomCode);
};